// extracted by mini-css-extract-plugin
export default {"containerStyles":"ProgressBar_containerStyles__q+YGe","fillerStyles":"ProgressBar_fillerStyles__sM9QT","labelStyles":"ProgressBar_labelStyles__syY4o"};